import Vue from 'vue';
import VueWait from 'vue-wait';

Vue.use(VueWait);

export default ({ app }) => {
  // eslint-disable-next-line no-param-reassign
  Vue.set(app, 'wait', new VueWait());
};



// WEBPACK FOOTER //
// ./src/plugins/vue-wait.js